import React from "react";
import "./styles.scss";

const Spinner = (props) => {
  return (
    <div className={"spinner-wrap"}>
      <h2 className={"spinner-text"}> {props.loadingMsg}</h2>{" "}
      <div className={`spinner  ${props.className} ${props.version ? props.version : ""} `}></div>
    </div>
  );
};

export default Spinner;
